import yup from '../../../config/yup';

export const awsElasticsearchReader5xValidationSchema = yup.object().shape({
  '@id': yup.string(),
  name: yup
    .string()
    .matches(/^[a-zA-Z_$][a-zA-Z0-9_$]*$/, {
      message:
        'Name must start with a letter or underscore and can only contain letters, numbers, and underscores',
    })
    .required('Name is required'),
  type: yup.string().default('awsElasticsearchReader5x'),
  delayedRead: yup.boolean(),
  parameterizedBy: yup.string(),
  connectionKey: yup.string(),
  properties: yup.object().shape({
    index: yup
      .string()
      .required('Index is required')

      .transform((value) => value.trim()),
    awsKey: yup.string().transform((value) => value.trim()),
    awsSecret: yup.string().transform((value) => value.trim()),
    awsRegion: yup.string().transform((value) => value.trim()),
    scroll: yup.string().transform((value) => value.trim()),
    elasticsearchEndpoint: yup.string().transform((value) => value.trim()),
    query: yup
      .string()
      .required('Query is required')

      .transform((value) => value.trim()),
  }),
});
